"use client";

import React from "react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../select.js";
import { Label } from "../label.js";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "../tooltip.js";
import { Calendar, ChevronDown } from "lucide-react";

interface EmailSelectProps {
  selectedEmail: string;
  handleEmailChange: (value: string) => void;
  emails: string[];
  label?: string;
  placeholder?: string;
  className?: string;
}

const EmailSelect = ({
  selectedEmail,
  handleEmailChange,
  emails,
  label = "Select Calendar",
  placeholder = "Select a calendar...",
  className,
}: EmailSelectProps) => {
  return (
    <div className={className}>
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>
            <div>
              <Label htmlFor="email-select" className="text-sm font-medium">
                {label}
              </Label>
              <Select value={selectedEmail} onValueChange={handleEmailChange}>
                <SelectTrigger className="w-full mt-2">
                  <Calendar className="h-4 w-4 mr-2" />
                  <SelectValue placeholder={placeholder} />
                  <ChevronDown className="h-4 w-4 opacity-50" />
                </SelectTrigger>
                <SelectContent>
                  {emails.map((email) => (
                    <SelectItem key={email} value={email}>
                      {email}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>
          </TooltipTrigger>
          <TooltipContent>
            <p>Choose a user to view their events</p>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
      <p className="text-xs text-muted-foreground mt-2 italic">
        Select a user's calendar to view their events.
      </p>
    </div>
  );
};

export default EmailSelect;
